import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import withData from 'util/hoc/with-data';
import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';


class DownloadReportButton extends React.PureComponent {
  static propTypes = {
    reportType: PropTypes.string.isRequired,
    data: PropTypes.any,
    children: PropTypes.object,
    component: PropTypes.node,
    graph_loading: PropTypes.bool,
    graph_data: PropTypes.any
  }

  handleLink = () => {
    const {
      graph_data
    } = this.props;

    window.open(resolve(graph_data, 'report/url', 'about:blank'), '_blank');
  }

  render() {
    const {
      component:Component='button',
      graph_loading,
      graph_data,
      ...props
    } = this.props;

    return (
      <Component onClick={this.handleLink} disabled={graph_loading||resolve(graph_data, 'report/error')} {...props}>
        {this.props.children||'Download Report'}
      </Component>
    );
  }

}

DownloadReportButton.query = async (token, { reportType, data={} }) => {
  if (typeof data !== 'string') {
    data = JSON.stringify(data);
  }

  return await Query(`
    {
      report (${jsonToInputParams({report_name: reportType, data: data})}) {
        url,
        bucket,
        path,
        error
      }
    }
  `);
};


export default withData(DownloadReportButton);
